import { Link, useParams } from "react-router-dom";

import { FormStates } from "components/Forms/FormStates";

import { getPlan } from "services/planService";

import { PlanForm } from "../form";

import { Button } from "components/Button";
import { PageFilter } from "components/Page/PageFilter";
import { PageHeader } from "components/Page/PageHeader";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { PLANS_QUERY_KEY } from "../viewModel";

type QueryParams = {
  id: string;
};

export function ShowPlan() {
  const { id } = useParams<QueryParams>();
  const { t } = useTranslation();

  const { data, isLoading, isError, refetch } = useQuery(
    [PLANS_QUERY_KEY, "form", id],
    () => getPlan(id!),
    { enabled: !!id }
  );

  return (
    <div>
      <div className="flex justify-between items-center">
        <PageHeader title={t("plans.see.title")} backPath="/planos" />
        <div className="flex items-center gap-3">
          <PageFilter hideAllFilters />
          <Link to={`/planos/editar/${id!}`}>
            <Button>{t("actions.edit")}</Button>
          </Link>
        </div>
      </div>
      <FormStates isLoading={isLoading} hasError={isError} onRetry={refetch} />
      {data && <PlanForm enabled={false} plan={data} />}
    </div>
  );
}

export default ShowPlan; 